import React from 'react'
import Back from './../Public/Image/Home/Back.svg'
import './GetLinkUsername.css'
import TextField from '@mui/material/TextField';
import CheckUsername from '../BottomSheet/CheckUsername';
import ShowPriceAndChannel from './../BottomSheet/ShowPriceAndChannel';
import { useState } from 'react';
import { setBottomSheetCheckUsername } from './../app/Home'
import { setUserNameForOrder } from './../app/Home'
import { GetCookie } from '../Action/GetCookie';
// import { CheckChannelBeforePurchase } from './../Api/CheckChannelBeforePurchase'
import { AllApi } from './../Api/AllApi'

import { useSelector, useDispatch } from 'react-redux'
import TooManyOrders from './../BottomSheet/TooManyOrders'
import TooManyOrdersUser from './../BottomSheet/TooManyOrdersUser'
import { setBottomSheetTooManyOrdersUser } from './../app/Home'
import { setBottomSheetTooManyOrdersUserTitle } from './../app/Home'
import { setBottomSheetTooManyOrdersUserDescription } from './../app/Home'

import ViolatingChannel from './../BottomSheet/ViolatingChannel'
import { setBottomSheetTooManyOrders } from './../app/Home'
import { setBottomSheetViolatingChannel } from './../app/Home'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ShowPriceAndChannelCoin from './../BottomSheet/ShowPriceAndChannelCoin'

import { setMiniLoading } from './../app/Home'
import { useHistory } from 'react-router-dom';
import { SetCookie } from './../Action/SetCookie'
import Member from './../Public/Image/wheel/member.png'

import { BottomSheet } from 'react-spring-bottom-sheet'
import Snackbar from '@mui/material/Snackbar';

const GetLinkUsername = () => {
    const dispatch = useDispatch()
    // const Email = useSelector((state) => state.counter.email)
    const MiniLoading = useSelector((state) => state.Home.MiniLoading)

    const [MemberReward, setMemberReward] = useState(false)
    const [MemberRewardCount, setMemberRewardCount] = useState('')
    function onDismiss() {
        setTimeout(() => {
            // dispatch(setBottomSheetPriceAndChannel(false))
            setMemberReward(false)
        }, 300);
    }



    const Token = GetCookie('Token')
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const ByCoin = searchParams.get('ByCoin');
    const Price = searchParams.get('Price');

    const history = useHistory();
    const UserNameForOrder = useSelector((state) => state.Home.UserNameForOrder)
    const [Snackopen, setSnackOpen] = useState(false)


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackOpen(false);
    };
    const [BottomSheetCheckUsernameGift, setBottomSheetCheckUsernameGift] = useState(false)
    const SaveSpinMember = async (UserNameForOrder) => {
        try {
            setBottomSheetCheckUsernameGift(false)
            const api = new AllApi();

            const giftRaw = localStorage.getItem("GiftUser");
            if (!giftRaw) {
                setSnackOpen(true);
                history.push('/Home?Status=Member')
                console.warn("No GiftUser found in localStorage.");
                return;
            }

            const gift = JSON.parse(giftRaw);

            // console.log("Gift token:", gift?.token, "Result:", UserNameForOrder);

            const res = await api.SaveSpin(gift.token, Token, UserNameForOrder);

            if (!res) {
                console.error("No response from SaveSpin API.");
                setSnackOpen(true);


                return;
            }

            switch (res.code) {
                case 301:
                    // console.log("You have already claimed the reward!");
                    setSnackOpen(true);
                    history.push('/Home?Status=Member')
                    break;

                case 200:
                    if (res?.data?.data?.claimReward) {
                        console.error("Reward already claimed!");
                        setSnackOpen(true); // نمایش خطا
                        history.push("/Home?Status=Member");
                        return;
                    }
                    setMemberRewardCount(gift.gift);
                    setMemberReward(true);

                    // پاک‌سازی داده‌ها
                    SetCookie("Gifttoken", null, -100);
                    // SetCookie("GiftTime", null, -100);

                    localStorage.removeItem("GiftUser");
                    break;

                default:
                    setSnackOpen(true);
                    console.warn("Unexpected API response:", res);
            }
        } catch (error) {
            console.error("Error while saving spin:", error);
        }
    }
    const HandleUsernameLink = async () => {
        dispatch(setMiniLoading(true))
        let result = Username.trim();
        result = result.toLowerCase();
        setUsernameErrorEmpty(false)
        setUsernameError(false)
        let PositionLink = result.search("https://t.me/");
        let PositionSign = result.search("@");
        if (PositionLink == 0) {

            result = result.replace('https://t.me/', '');

        } else if (PositionSign == 0) {

            result = result.replace('@', '');

        } else {
            result = result
        }

        if (result.length > 4) {
            // console.log(isValidTelegramUsername(result))
            if (isValidTelegramUsername(result)) {
                setUsernameError(false)

            } else {

                setUsernameError(true)
            }
        } else {
            setUsernameError(false)

        }



        if (result.length == 0) {
            setUsernameErrorEmpty(true)
            dispatch(setMiniLoading(false))

        } else {
            if (UsernameError == false && UsernameErrorEmpty == false) {
                if (result.length < 4 && result.length >= 0) {
                    setUsernameError(true)
                } else {
                    if (Price === '0') {
                        if (isValidTelegramUsername(result)) {
                            console.log(3)
                            dispatch(setUserNameForOrder(result))

                            setBottomSheetCheckUsernameGift(true)
                        }else{
                             setUsernameError(true)
                             console.log('eee')
                        }


                    } else {
                        const MakeApiClass = new AllApi();
                        let res = await MakeApiClass.CheckChannelBeforePurchase(Token, result)
                        // let res = await CheckChannelBeforePurchase(Token, result)

                        if (res.code == 200) {
                            dispatch(setBottomSheetCheckUsername(true))
                            dispatch(setUserNameForOrder(result))
                        } else if (res.code == 304) {
                            dispatch(setBottomSheetTooManyOrders(true))
                        } else if (res.code == 303) {
                            // setBottomSheetViolatingChannel
                            dispatch(setBottomSheetViolatingChannel(true))

                        } else if (res.code == 305) {
                            // username format
                            setUsernameError(true)
                        } else if (res.code == 306) {
                            // username format

                            dispatch(setBottomSheetTooManyOrdersUserTitle(res.message.title))
                            dispatch(setBottomSheetTooManyOrdersUserDescription(res.message.description))

                            dispatch(setBottomSheetTooManyOrdersUser(true))
                        } else if (res.code == 120 || res.code == 121 || res.code == 122 || res.code == 123) {
                            let name = "Token"
                            let name1 = "active"
                            document.cookie = name + '=; Max-Age=-99999999;';
                            document.cookie = name1 + '=; Max-Age=-99999999;';


                            history.push("/");
                            // dispatch(setLoading(false))

                        }
                    }


                }
                dispatch(setMiniLoading(false))
            }


        }


    }
    useEffect(() => {
        // dispatch(setBottomSheetTooManyOrders(true))
        // dispatch(setBottomSheetViolatingChannel(true))

    }, [])






    const [LastUsername, setLastUsername] = useState('')
    const [Username, setUsername] = useState('')
    const [UsernameError, setUsernameError] = useState(false)
    const [UsernameErrorEmpty, setUsernameErrorEmpty] = useState(false)
    // const telegramUsernameRegex = /^[a-zA-Z][a-zA-Z0-9_]{3,31}$/;
    const telegramUsernameRegex = /^[a-zA-Z][a-zA-Z0-9_]{3,30}[a-zA-Z0-9]$/;

    function isValidTelegramUsername(username) {
        return telegramUsernameRegex.test(username);
    }
    const HandleChange = (value) => {
        let result = value.trim();

        setUsername(result)
        setUsernameErrorEmpty(false)
        setUsernameError(false)
    }

    return (
        <div className='GetLinkUsername'>
            <div className='GetLinkUsernameHeader'>
                <Link to="/Home" className="GetLinkUsernameHeaderLink">  <img src={Back} className='GetLinkUsernameHeaderImg' />
                </Link>
                <div className='GetLinkUsernameHeaderText'>
                    Channel/Group Link
                </div>
            </div>
            <div className='GetLinkUsernameContent'>
                <div className='GetLinkUsernameContentText1'>
                    Please enter your Telegram Channel/Group Link
                </div>
                <div className='GetLinkUsernameInputContainer'>
                    {

                        UsernameErrorEmpty ?
                            <TextField
                                error
                                id="outlined-error"
                                label="Link"
                                defaultValue="Hello World"
                                className='GetLinkUsernameInput'
                                onChange={(e) => HandleChange(e.target.value)}
                                value={Username}
                                helperText="field is empty"
                            />
                            :
                            UsernameError ?
                                <TextField
                                    error
                                    id="outlined-error"
                                    label="Link"
                                    defaultValue="Hello World"
                                    className='GetLinkUsernameInput'
                                    onChange={(e) => HandleChange(e.target.value)}
                                    value={Username}
                                    helperText="format is incorrect"
                                />
                                : <TextField id="outlined-basic"
                                    label="Link"
                                    variant="outlined"
                                    className='GetLinkUsernameInput'
                                    // onChange={(e) => HandleChange(e.target.value)}
                                    onChange={(e) => HandleChange(e.target.value)}
                                    value={Username}

                                />
                    }


                </div>
                <div className='GetLinkUsernameContentText'>
                    Please ensure the following before placing an order:
                </div>
                <ul className='GetLinkUsernameContentTextUl'>
                    <li>
                        The channel/group must be public
                    </li>
                    <li>
                        Turn off approve new members in group
                    </li>
                </ul>
            </div>
            <div className='GetLinkUsernameFooter'>
                <button className='GetLinkUsernameFooterButton' onClick={() => HandleUsernameLink()}>
                    {MiniLoading ?
                        <div className='LoaderContainer'>
                            <div className="loadminijoin"></div>
                        </div>

                        :
                        'Next'
                    }
                </button>
            </div>
            {
                ByCoin == 'true' ? <ShowPriceAndChannelCoin /> : <ShowPriceAndChannel />
            }
            <CheckUsername />

            <TooManyOrders />
            <TooManyOrdersUser />

            <ViolatingChannel />
            <BottomSheet onDismiss={onDismiss}
                open={MemberReward}
            >
                <div className='RegisterBeforeBottomSheet'>
                    <div className='RegisterBeforeBottomSheetHeader'>
                        <div className={`RegisterBeforeBottomSheetHeaderText `}>
                            <div >
                                🎉 Reward Claimed  🎉
                            </div>
                        </div>
                    </div>
                    <div className='RegisterBeforeBottomSheetBody' style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                        {MemberRewardCount} <img width={18} height={18} src={Member} style={{ margin: "0 4px 0 4px" }} />    are sending to {UserNameForOrder}
                    </div>
                    <div className='RegisterBeforeBottomSheetFooter'>
                        {/* <button className='BottomSheetCancelButton' onClick={() => setCoinReward(false)}>got it</button> */}
                        <button className='BottomSheetLoginButton' style={{ width: "100%" }} onClick={() => { setMemberReward(false); history.push('/Home?Status=Member') }}>Got it</button>
                    </div>
                </div>
            </BottomSheet>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={Snackopen}
                autoHideDuration={4000}
                onClose={handleClose}
                message=" Something went wrong!"
            // action={action}
            />
            <BottomSheet onDismiss={onDismiss} open={BottomSheetCheckUsernameGift}>
                <div className='RegisterBeforeBottomSheet'>
                    <div className='RegisterBeforeBottomSheetHeader'>
                        <div className={`RegisterBeforeBottomSheetHeaderText ${UserNameForOrder.length > 24 ? 'scrolling-text-container' : null} `}>
                            <div className={`${UserNameForOrder.length > 24 ? "scrolling-text" : null}`}>@{UserNameForOrder}</div>
                        </div>
                    </div>
                    <div className='RegisterBeforeBottomSheetBody'>
                        Are you sure
                        <span className='UserNameChannelBold ' >
                            @{UserNameForOrder}
                        </span>

                        is the username you are looking for?
                    </div>
                    <div className='RegisterBeforeBottomSheetFooter'>
                        <button className='BottomSheetCancelButton' onClick={() => setBottomSheetCheckUsernameGift(false)}>Cancel</button>
                        <button className='BottomSheetLoginButton' onClick={() => SaveSpinMember(UserNameForOrder)}>Yes, next</button>
                    </div>
                </div>
            </BottomSheet>
        </div>
    )
}

export default GetLinkUsername